import { createContext, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

export const MIContext = createContext();

const MIContextProvider = (props) => {
  const globaluserData = useSelector((state) => state.commonReducer);
  let role = globaluserData.role;
  // const role = sessionStorage.getItem("role");
  const reduxValues = useSelector((state) => state.MIReducer);
  // Service Type Filter
  const [serviceType, setServiceType] = useState(
    reduxValues.serviceType || "all"
  );
  // Service Filter
  const [service, setService] = useState(reduxValues.service || "all");
  // Date Filter
  const [dateFilter, setDateFilter] = useState(
    (reduxValues.dateFilter.startDate !== "" && reduxValues.dateFilter) || {
      startDate:
        role === "admin" ? "" : new Date(`${moment().subtract(1, "year")}`),
      endDate: role === "admin" ? "" : new Date(`${moment()}`),
      key: "selection",
      color: "#99adad",
    }
  );
  // Statistics card Filter
  const [statisticsFilter, setStatisticsFilter] = useState(
    reduxValues.statisticsFilter || "All"
  );
  // Organisation Filter
  const [organisationID, setOrganisationID] = useState(
    reduxValues.organisationID || null
  );
  //  Assignment Filter Modal Toggle
  const [filterModal, setFilterModal] = useState(false);

  const [currentSelection, setCurrentSelection] = useState({});
  const [anchorPopover, setAnchorPopover] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewAction, setViewAction] = useState(null);
  const [isFeedback, setIsFeedback] = useState(false);
  const [action, setAction] = useState("");

  // MI Table Search

  const [tableSearch, setTableSearch] = useState(
    reduxValues.tableSearch || {
      searchCategory: "",
      searchText: "",
    }
  );

  const [totalCount, setTotalCount] = useState(100);
  const [assignmentData, setAssignmentData] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);

  const [modules, setModules] = useState(null);
  const [statistics, setStatistics] = useState({});
  const [pageSize, setPageSize] = useState(100);
  const [page, setPage] = useState(0);

  const valueOBJ = {
    serviceType,
    setServiceType,
    dateFilter,
    setDateFilter,
    statisticsFilter,
    setStatisticsFilter,
    organisationID,
    setOrganisationID,
    anchorPopover,
    setAnchorPopover,
    currentSelection,
    setCurrentSelection,
    isFeedback,
    setIsFeedback,
    viewAction,
    setViewAction,
    anchorEl,
    setAnchorEl,
    filterModal,
    setFilterModal,
    action,
    setAction,
    service,
    setService,
    tableSearch,
    setTableSearch,
    totalCount,
    setTotalCount,
    assignmentData,
    setAssignmentData,
    tableLoader,
    setTableLoader,
    modules,
    setModules,
    statistics,
    setStatistics,
    pageSize,
    setPageSize,
    page,
    setPage,
  };
  return (
    <MIContext.Provider value={valueOBJ}>{props.children}</MIContext.Provider>
  );
};

export default MIContextProvider;
